export const dropdownButtonClasses = {
  active: 'dropdown-button-active',
  withHeading: 'dropdown-with-heading',
  icon: 'dropdown-button-icon',
  fullWidth: 'dropdown-button-full-width',
  fullWidthWithSpace: 'dropdown-button-full-width-with-space',
}
